import { useDispatch, useSelector } from "react-redux";
import { globalErrorSelector, setGlobalError } from "../Slice/ShowGlobalErrorSlice";
import { Alert, Snackbar, Typography } from "@mui/material";

function ShowGlobalError() {
    const globalError = useSelector(globalErrorSelector);
    const dispatch = useDispatch();

    if (!globalError) {
        return null;
    }

    function handleClose() {
        dispatch(setGlobalError(null));
    }

    return (
        <Snackbar
            open={globalError !== null}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
            <Alert
                onClose={handleClose}
                severity="error"
                variant="filled"
                sx={{ whiteSpace: 'pre-line' }}
            >
                {globalError.message}
                <Typography component="div" variant="caption" sx={{ mt: 0.75 }}>
                    Код ошибки: {globalError.code}
                </Typography>
            </Alert>
        </Snackbar>
    );
}

export default ShowGlobalError;
